import React from 'react';
import { connect } from 'react-redux';
import SystemCohortPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from './SystemCohortPanelContainer';
import CohortErrorMessages from '../../components/CohortErrorMessages';
import CohortNoDatasetAccess from '../../containers/CohortNoDatasetAccess';
import CohortInfoGridCompact from '../../components/CohortInfoGridCompact';
import SystemCohortMessage from '../components/SystemCohortMessage';

const SystemCohortPanelNarrow = ({
  code, // requestCode
  cohortCode,
  category,
  readErrors,
  validationErrors,
  updateProperties,
  onChange,
  url,
  queryAccess,
  allowCohortVisualisations,
  request,
  userCohort,
}) => (
  <SystemCohortPanelContainer
    code={code}
    category={category}
    onChange={onChange}
    url={url}
  >
    <div className="aridhia-system-cohort-panel-narrow overflow-x-hidden">
      <CohortErrorMessages
        code={code}
        category={category}
        entities={['server', 'cohort', 'query', 'clause', 'filter']}
        isSystemCohort
        readErrors={readErrors}
        validationErrors={validationErrors}
        updateProperties={updateProperties}
      />
      {!queryAccess && (<CohortNoDatasetAccess code={code} category={category} />)}
      {cohortCode && (
        <>
          <SystemCohortMessage
            request={request}
            userCohort={userCohort}
          />
          <CohortInfoGridCompact
            category={category}
            code={cohortCode}
            allowCohortVisualisations={allowCohortVisualisations}
            queryAccess={queryAccess}
          />
        </>
      )}
    </div>
  </SystemCohortPanelContainer>
);

export default connect(mapStateToProps, mapDispatchToProps)(SystemCohortPanelNarrow);
